import isNative from '@unifyapps/network/utils/native/isNative';

export const UA_THEME_VARS = 'ua-variables' as const;
export const INTERFACE_THEME = 'interface-theme' as const;

/**
 * DOM node that carries interface theme tokens (tailwind + CSS variables).
 * Extracted so both useInterfaceStyles and semantic map probes share one lookup.
 */
export const getInterfaceThemeRootElement = (): HTMLElement | null => {
  if (isNative()) {
    return null;
  }
  if (typeof document === 'undefined') {
    return null;
  }
  const interfaceNode = document.querySelector(`.${UA_THEME_VARS} .${INTERFACE_THEME}`);
  const platformNode = !interfaceNode ? document.querySelector(`.${UA_THEME_VARS}`) : null;
  return (interfaceNode || platformNode) as HTMLElement | null;
};
